export const sliderStyles = {
  color: '#377DFF',
  height: 6,
  '& .MuiSlider-thumb': {
    width: 18,
    height: 18,
    backgroundColor: '#fff',
    border: '3px solid #377DFF'
  },
  '& .MuiSlider-rail': { opacity: 0.1, backgroundColor: '#fff' }
};
